import React from "react";
import { useNavigate } from "react-router-dom";

const ServiceNotAvailable = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Service Under Development</h1>
      <p style={styles.message}>
        This service is currently under development. Please check back later.
      </p>
      <button style={styles.button} onClick={() => navigate("/")}>
        Go to Home
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "70vh",
    backgroundColor: "#f7f9fc",
    color: "#2c3e50",
    textAlign: "center",
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "1rem",
  },
  message: {
    fontSize: "1.2rem",
    marginBottom: "2rem",
  },
  button: {
    padding: "0.8rem 1.5rem",
    fontSize: "1rem",
    fontWeight: "bold",
    color: "#fff",
    backgroundColor: "#f39c12",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default ServiceNotAvailable;
